function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("We know conversions don’t come from the first session. Sometimes it takes weeks, even months, often using multichannel communication. This is something the conventional analytics tools fail to recognize. WhiteBox tracks multichannel traffic coming from Google, Facebook, MailChimp, Email, SMS, Viber, offline data, etc and attributes conversions properly. With WhiteBox you could find out:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The complete behavior of your web visitors.")]),_vm._v(" "),_c('li',[_vm._v("What type of traffic works best for generating new customers?")]),_vm._v(" "),_c('li',[_vm._v("What is your long-term relationship with your customers?")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/home/traffic-insights/details","summary":"Where did the conversions come from?"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }